import React from 'react';
import PropTypes, { oneOf } from 'prop-types';
import { StyledRadios, StackedIcons, Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { CHAT_TYPE } from '../../../constants/constants';
import { FORM_KEYS } from '../../../constants/formKeys';

export const ChatTypeSelection = ({ chatType, formContext, isDisabled }) => {
  const chatTypeRadios = [
    {
      label: 'Video',
      value: CHAT_TYPE.VIDEO,
      labelCssClass: {
        checked: 'button primary',
        unchecked: 'button primary outline'
      },
      icon: {
        checked: (
          <StackedIcons
            customCssClass="offsetTick"
            icons={[
              <Icon
                key="icon1"
                icon="radio-unchecked"
              />,
              <Icon
                key="icon2"
                icon="tick"
                customCssClass="reveal animate-slow animate-once"
              />
            ]}
          />
        ),
        unchecked: <Icon icon="radio-unchecked" />
      }
    },
    {
      label: 'Text',
      value: CHAT_TYPE.TEXT,
      labelCssClass: {
        checked: 'button primary',
        unchecked: 'button primary outline'
      },
      icon: {
        checked: (
          <StackedIcons
            customCssClass="offsetTick"
            icons={[
              <Icon
                key="icon1"
                icon="radio-unchecked"
              />,
              <Icon
                key="icon2"
                icon="tick"
                customCssClass="reveal animate-slow animate-once"
              />
            ]}
          />
        ),
        unchecked: <Icon icon="radio-unchecked" />
      }
    }
  ];

  return (
    <>
      <h3>Select type of chat</h3>

      <StyledRadios
        fieldFormContext={formContext}
        groupName="chatType"
        name={FORM_KEYS.CHAT_TYPE}
        value={chatType}
        disabled={isDisabled}
        customCssClass={isDisabled ? 'disabled' : ''}
        validation={{
          required: true
        }}
        radioInputs={chatTypeRadios}
        required
      />
    </>
  );
};

ChatTypeSelection.propTypes = {
  chatType: oneOf([CHAT_TYPE.VIDEO, CHAT_TYPE.TEXT]),
  isDisabled: PropTypes.bool,
  formContext: PropTypes.shape({
    chatType: oneOf([CHAT_TYPE.VIDEO, CHAT_TYPE.TEXT])
  })
};
